// extracted by mini-css-extract-plugin
module.exports = {"loader":"Home_loader__y-4e-","container":"Home_container__10fFQ"};